export default {"src":"/_next/static/media/Group-254933-1.9fd2b622.svg","height":126,"width":126};